
  // inview.js
$(document).ready(function () {
    setTimeout(function () {
        $('.inview').on('inview', function(event, isInView) {
      if (isInView) {
          $(this).stop().addClass('yellowline');
      } else {
          $(this).stop().removeClass('yellowline');
      }
    });
    }, 3000);
});


//mobile-menu accordion
$(function () {
  // タイトルをクリックすると
  $(".accordion-title").on("click", function () {
    // クリックした次の要素(コンテンツ)を開閉
    $(this).next().slideToggle(300);
    // タイトルにopenクラスを付け外しして矢印の向きを変更
    $(this).toggleClass("open", 300);
  });
});


//recommend
setTimeout(function () {
  $('.evm_wiser_heading').addClass('yellowline_animation inview yellowline');
  $('.ws-card__price span').addClass('ws-original-price-both');
  $('span.ws-original-price-both').append(tax_included);
},3000)


//Product: stock
$(function(){
  if($('body').hasClass('template-product')){
    console.log(stockList);
    set_StockStatus();
    $('.block-swatch__item').click(function(){
      setTimeout(function () {
        set_StockStatus();
      },100);
    });
  }
  function set_StockStatus(){
    var stock_txt = '';
    var stock = stockList[$('select[name="id"]').val()];
    if(!stock){ 
      stock_txt = 'SOLD OUT';
    }else if(stock === 1){
      stock_txt = '残りわずか';
    }
    $('.product-form__selected-stock').html(stock_txt);
  }
});
